export default __webpack_public_path__ + "static/media/icon_diamond.983d0d6f.svg";